var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-pastille d-flex flex-wrap justify-content-center"},_vm._l((_vm.pastilles),function(p,index){return _c('pastille',{key:index,attrs:{"price":p.price,"color":p.color,"text-color":p.text_color}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }